import * as jschannel from "@greenova/jschannel";
import * as jscookie from 'js-cookie';

export class XdmProviderApi {
    private jsChannel: jschannel.Channel;

    constructor(private scopeName: string) {
        var channConfig: jschannel.ChannelConfig = {
            window: window.parent,
            origin: "*",
            scope: this.scopeName,
            reconnect: true
        }

        this.jsChannel = jschannel.build(channConfig);

        this.jsChannel.bind('getOrSetCookie', (trans, params) => this.getOrSetCookie(params.cookieName, params.value, params.expires));
        this.jsChannel.bind('setCookie', (trans, params) => this.setCookie(params.cookieName, params.value, params.expires));
        this.jsChannel.bind('getCookie', (trans, params) => this.getCookie(params.cookieName));
        this.jsChannel.bind('removeCookie', (trans, params) => this.removeCookie(params.cookieName));
    }

    public getOrSetCookie(cookieName: string, value: string | undefined, expires?: number): string | undefined {
        var cookie = this.getCookie(cookieName);
        if (cookie)
            return cookie;
        if (value) {
            this.setCookie(cookieName, value, expires);
            return this.getCookie(cookieName);
        }

        return undefined;
    }

    public setCookie(cookieName: string, value: string, expires?: number): void {
        let options: Cookies.CookieAttributes = {
            domain: location.hostname,//TODO
            path: '/',
            expires: expires || 730
        };
        jscookie.set(cookieName, value, options);
    }

    public getCookie(cookieName: string): string | undefined {
        var value = jscookie.get(cookieName);
        if (value) {            
            return value;
        }
        return undefined;
    }

    public removeCookie(cookieName: string): void {
        jscookie.remove(cookieName);
    }  
}
